import loader from '../moduleLoader.js'

function Share(shareLink) {

    let socialMediaUrls = {
        facebook: 'https://www.facebook.com/sharer.php?u=',
        twitter: 'https://twitter.com/intent/tweet?url=',
        linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url='
    }


    function init() {

        shareLink.addEventListener('click',
            function (e) {
                var socialMedia = shareLink.getAttribute('data-share-for');
                var url = socialMediaUrls[socialMedia];
                shareOnSocials(e, url);
            });
    };



    function shareOnSocials(e, url) {
        e.preventDefault();

        var left = void 0 !== window.screenLeft ? window.screenLeft : screen.left
            , top = void 0 !== window.screenTop ? window.screenTop : screen.top
            , iw = (window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width) / 2 - 250 + left
            , ih = (window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height) / 2 - 150 + top
            , href = location.href
            , r = [];
        r.push("width=500"),
            r.push("height=600"),
            r.push("top=" + ih),
            r.push("left=" + iw);
        window.open(url + encodeURIComponent(href), "sharer", r.join(","));
    }

    return {
        init: init
    }
}

loader.add('Share', Share);

export default Share